import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqItems } from "@/mocks/drama";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <Reveal className="lg:col-span-4">
            <p className="flex items-center gap-2 font-label text-sm tracking-[0.3em] text-primary-600">
              <i className="ri-question-answer-line" />
              常 见 问 题
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              关于大结局与剧情，大家常问这些
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">
              把高频疑问集中整理，快速帮你缩小需要查找的范围。如果还有别的疑问，可以带着具体问题继续往下读对应分区。
            </p>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqItems.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <Reveal key={item.q} delay={idx * 45}>
                    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? null : idx)}
                        className="flex w-full items-center gap-4 px-5 py-4 text-left transition hover:bg-background-200/60 md:px-6"
                      >
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                          Q
                        </span>
                        <span className="flex-1 font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <i
                          className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                            isOpen ? "rotate-180" : ""
                          } ri-arrow-down-s-line`}
                        />
                      </button>
                      {isOpen && (
                        <div className="animate-slide-down border-t border-background-200 px-5 py-4 md:px-6">
                          <div className="flex items-start gap-3">
                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-bold text-accent-700">
                              A
                            </span>
                            <p className="text-sm leading-loose text-foreground-700">{item.a}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}